import dayjs from 'dayjs';
import {Guest, GUEST_FORM_NAMES, PhoneDetails, SelectOption} from '@chekin/core';
import {isDateField, isPhoneField} from '../guestForm';

type BuildGuestFormDataFromSDKPrefillingArgs = {
  guestData: Partial<Guest>;
};
const buildGuestFormDataFromSDKPrefilling = ({
  guestData,
}: BuildGuestFormDataFromSDKPrefillingArgs) => {
  if (!guestData) return;
  const guestValues = Object.entries(guestData);
  const preloadedData: {[key: string]: string | SelectOption | PhoneDetails | Date} = {};

  guestValues.forEach(([fieldName, fieldValue]: [string, unknown]) => {
    const isFieldExist = Object.values(GUEST_FORM_NAMES).includes(
      fieldName as GUEST_FORM_NAMES,
    );

    if (!isFieldExist || !fieldValue) return;

    const isDateValue = isDateField(fieldName);

    if (isPhoneField(fieldName)) {
      preloadedData[fieldName] = fieldValue;
      return;
    }

    if (isDateValue) {
      preloadedData[fieldName] = dayjs(fieldValue as string).toDate();
      return;
    }

    preloadedData[fieldName] = fieldValue;
  });

  return preloadedData;
};

export {buildGuestFormDataFromSDKPrefilling};
